const mutations = {
  getPrivacyPolicys: (state, privacy_policy) => {
    state.privacy_policy = privacy_policy;
  },
  getPrivacyPolicy: (state, privacy_policy_id) => {
    state.privacy_policy_id = privacy_policy_id;
  },
  postPrivacyPolicy: (state, new_privacy_policy) => {
    state.privacy_policy.push(new_privacy_policy);
  },
  putPrivacyPolicy: (state, payload) => {
    state.privacy_policy = state.privacy_policy.map((privacy_policy) => {
      if (privacy_policy.privacy_policy_id === payload.id) {
        return Object.assign({}, privacy_policy, payload.formData);
      }
      return privacy_policy;
    });
  },
  delPrivacyPolicy(state, id) {
    const index = state.privacy_policy.findIndex(privacy_policy => privacy_policy.privacy_policy_id == id);
    state.privacy_policy.splice(index, 1);
  },
};

export default mutations;
